import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { AdminUsersService } from '../../admin-users/services/admin-users.service';
import { AuthDataStorageService } from '../services/auth-data-storage.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService, private authDataStorageService: AuthDataStorageService, private adminUsersService: AdminUsersService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLoggedIn = await this.authService
      .verifyUserIsLoggedIn()
      .toPromise()
      .then(() => true)
      .catch(() => false);

    if (isLoggedIn) {
      const id = this.authDataStorageService.getLoggedUserId();
      const is2faEnabled = await this.adminUsersService
        .is2faEnabled(id)
        .toPromise()
        .then(res => res.text() === 'true');

      if (is2faEnabled) {
        return true;
      } else {
        this.router.navigate(['/2fa']);
        return false;
      }
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/auth/guard/auth.guard.ts